var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12a8.5 8.5 0 118.5 8.5 8.456 8.456 0 01-4.542-1.315 1 1 0 00-.821-.113l-2.88.86 1.085-2.538a1 1 0 00-.07-.92A8.455 8.455 0 013.5 12zM12 1.5C6.2 1.5 1.5 6.2 1.5 12c0 1.837.473 3.567 1.305 5.072L1.08 21.106a1 1 0 001.206 1.351l4.5-1.342A10.457 10.457 0 0012 22.499c5.799 0 10.5-4.7 10.5-10.5C22.5 6.201 17.799 1.5 12 1.5zm2.293 12.681l-1.315.926A9.337 9.337 0 0111 13.584a10.205 10.205 0 01-1.624-2.114l.835-.709a1 1 0 00.236-1.231l-1.064-2a1 1 0 00-1.54-.283l-.316.275c-.76.662-1.208 1.75-.836 2.852a12.048 12.048 0 002.895 4.625c1.813 1.813 3.655 2.527 4.733 2.805.868.223 1.689-.076 2.268-.548l.59-.482a1 1 0 00-.12-1.634l-1.677-1a1 1 0 00-1.088.041z",
    fill: "#0A3F6E"
  })));
}

export default SvgWhatsapp;